import * as React from 'react';
import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton, Grid } from '@mui/material'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import colors from '../colors'

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#ffffff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 500,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  export default function HtmlTooltip(props) {
    return (
        <CustomTooltip
          title={
            <React.Fragment>
              {Object.entries(props.invoiceDetails).map(invoiceDetail => {
                  return <>
                    <Grid container item md={12} pl={'2%'} pt={'3%'} pb={'3%'}>
                        <Grid item md={6} sm={6} xs={6}><Typography sx={{fontFamily:'GerberaBold', color:colors.darkBlue}} >{invoiceDetail[0]}:</Typography></Grid>
                        <Grid item md={6} sm={6} xs={6}><Typography sx={{color:colors.gray, fontFamily:'GerberaLight'}}>{invoiceDetail[1]}</Typography></Grid>
                    </Grid>    
                  </>    
              })}
            </React.Fragment>
          }
        >
            <IconButton disableRipple={true} >
                <InfoIcon />
            </IconButton>
        </CustomTooltip>
    );
  }